<template>
  <v-alert
    v-bind="$props"
    class="w-alert"
    border="left"
    colored-border
    outlined
    dismissible
  >
    <template
      v-if="$slots.prepend"
      slot="prepend"
    >
      <div class="w-alert__prepend">
        <slot name="prepend" />
      </div>
    </template>

    <div class="w-alert__content d-flex justify-space-between flex-wrap">
      <div class="w-alert__content__wrapper">
        <div class="w-alert-content__title w-h4">
          <slot name="content-title" />
        </div>
        <div class="w-alert__content__text">
          <slot name="content-text" />
        </div>

        <div class="w-alert__content__button d-sm-none align-self-end">
          <w-btn
            v-if='closeable'
            text
            @click="invokeClose"
          >
            {{ closeText }}
          </w-btn>
        </div>
      </div>
    </div>

    <template #close="{ toggle }">
      <w-btn
        v-if='closeable && !$vuetify.breakpoint.xsOnly'
        text
        class="align-self-end"
        @click="invokeClose"
      >
        {{ closeText }}
      </w-btn>
    </template>
  </v-alert>
</template>

<script>
import { VAlert } from "vuetify/lib";
import i18n from "@/language/i18n";

export default {
  name: "WorkAlert",
  props: {
    ...VAlert.options.props,
    icon: { default: false },
    closeable: { type: Boolean, default: true },
    dense: { type: Boolean, default: true },
    closeText: { type: String, default: i18n.t('Common.close') },
    close: { type: Function, default: undefined }
  },
  methods: {
    invokeClose() {
      if (this.close) {
        return this.close();
      }
      return this.handleClose();
    },
    handleClose() {
      this.$emit('close_alert');
    }
  },
}
</script>

<style lang="scss">
.w-alert {
  border: 0 !important;
  margin-bottom: $grid-gutter;
  background-color: $w-unit-bg-color !important;

  &__prepend {
    margin-right: 1rem;
  }

  .w-alert__content {
    &__wrapper {
      display: flex;
      flex-direction: column;
      word-break: break-all;
    }
    &__text {
      @include w-p4;
      color: $input-read-only-color;
      word-break: break-word;
    }
  }

  .v-btn {
    height: auto !important;
  }


  .v-icon {
    align-self: center;
  }
}
</style>
